import { ChangeEvent } from "react";
import { Input as InputAntd } from "antd"

import { EItemFormatType, IItemField } from "../../interfaces";

import ErrorMessage from "../ErrorMessage";

interface IProps {
  field: IItemField;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>, format?: EItemFormatType, currency_min_value?: number | null, currency_max_value?: number | null, options?: { forceValidate?: boolean }) => void;
  error?: { message: string };
}

export default function CollectField({
  field,
  value,
  error,
  onChange
}: IProps) {
  const hasError = !!error;

  return (
    <div>
      <InputAntd
        placeholder={field.placeholder}
        name={field.name}
        type={field.type}
        onChange={(e) => onChange(e, field.format, field.currency_min_value, field.currency_max_value)}
        onBlur={(e) => onChange(e, field.format, field.currency_min_value, field.currency_max_value, { forceValidate: true })}
        value={value}
        prefix={field.format === EItemFormatType.CURRENCY ? "R$" : ""}
        maxLength={field.format === EItemFormatType.CELLPHONE ? 15 : undefined}
        style={{
          background: hasError ? "#fff6f6" : '#FFFFFF',
          outline: 0,
          padding: "6px 12px",
          borderRadius: 4,
          fontSize: "1rem",
          color: "#212121",
          border: `1px solid ${hasError ? "#ff4d4f" : "#E8E8E8"}`,
        }}
      />

      {
        hasError && (
          <ErrorMessage message={error.message} />
        )
      }
    </div>
  )
}
